import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="sidebar"
export default class extends Controller {
  static targets = ["label", "drawer"]
  static values = { mobileOpen: Boolean }

  connect() {
    // Create overlay element for mobile
    this.overlay = document.createElement('div')
    this.overlay.className = 'fixed inset-0 bg-black/50 z-30 hidden'
    this.overlay.addEventListener('click', () => this.closeMobile())
    document.body.appendChild(this.overlay)

    // The drawer is data-turbo-permanent and survives Turbo navigation, while
    // this controller reconnects on each page. Sync state from the actual DOM
    // so we don't desync (cause of the "tap twice to close" bug).
    this.syncFromDom()
  }

  disconnect() {
    if (this.overlay) {
      this.overlay.remove()
    }
  }

  syncFromDom() {
    if (!this.hasDrawerTarget) {
      this.mobileOpenValue = false
      return
    }

    const visuallyOpen = this.drawerTarget.classList.contains('translate-x-0')
    this.mobileOpenValue = visuallyOpen
    this.overlay.classList.toggle('hidden', !visuallyOpen)
    document.body.classList.toggle('overflow-hidden', visuallyOpen)
  }

  toggleMobile() {
    if (this.mobileOpenValue) {
      this.closeMobile()
    } else {
      this.openMobile()
    }
  }

  // Auto-close the drawer when the user taps a nav link on mobile. Without
  // this, the drawer stays open after Turbo navigates and covers the new page.
  closeOnNavigate(event) {
    // md breakpoint — drawer is permanent above this width.
    if (window.matchMedia('(min-width: 768px)').matches) return

    // Only navigation triggers: anchor links and form submit buttons
    // (button_to). Excludes the dropdown collapse toggle (type="button").
    const trigger = event.target.closest('a, button[type="submit"]')
    if (!trigger) return

    this.closeMobile()
  }

  openMobile() {
    if (!this.hasDrawerTarget) return

    this.mobileOpenValue = true
    this.drawerTarget.classList.remove('-translate-x-full')
    this.drawerTarget.classList.add('translate-x-0')
    this.labelTargets.forEach(label => label.classList.remove("hidden"))
    this.overlay.classList.remove('hidden')
    document.body.classList.add('overflow-hidden')
  }

  closeMobile() {
    if (!this.hasDrawerTarget) return

    this.mobileOpenValue = false
    this.drawerTarget.classList.remove('translate-x-0')
    this.drawerTarget.classList.add('-translate-x-full')
    this.labelTargets.forEach(label => {
      label.classList.add("hidden")
      label.classList.add("md:group-hover:block")
    })
    this.overlay.classList.add('hidden')
    document.body.classList.remove('overflow-hidden')
  }
}
